import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import ReactImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import { Card, CardContent } from "../../../components/ui/card";
import { getSingleProduct } from "../api/getSingleProduct";
import { useAuth } from "../../../lib/auth";
import storage from "../../../utils/storage";
import { Loading } from "../../../components/elements/loading";
import bgImage from "../../../asset/bg.svg";
import { Textarea } from "../../../components/ui/textarea";
import { getDelverFee } from "../../cart/api/getDelverFee";
import { getProducts } from "../api/getProducts";
import { Modal } from "antd";

type Product = {
  id: number;
  name: string;
  price: number;
  image: string;
  category: string;
  type: string;
  manufacturer: string;
  size: string;
  details: string;
  images: Image[];
};

type Image = {
  id: number;
  product_id: string;
  image_path: string;
  created_at: string;
  updated_at: string;
};

export const SingleProduct = () => {
  const { id, productId } = useParams<{ id: any; productId: string }>();
  const [quantity, setQuantity] = useState(0);
  const [quantityButton, setQuantityButton] = useState(1);
  const [productsData, setProductsData] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [singleProductData, setSingleProductData] = useState<any>();
  const [productImages, setProductImages] = useState([]);
  const { user, incrementOrderCount } = useAuth();
  const [totalAmount, setTotalAmount] = useState<number>(0);
  const [cartProducts, setCartProducts] = useState<any[]>([]);
  const navigate = useNavigate();
  const [deliveryFee, setDeliveryFee] = useState<any>(0);
  const [buttonState, setButtonState] = useState<"add" | "added" | "remove">(
    "add"
  );
  const [isDialogVisible, setDialogVisible] = useState(false);
  const handleProducts = async () => {
    const response = await getProducts();
    setProductsData(response.data.products);
  };

  useEffect(() => {
    handleProducts();
  }, []);

  const fetchDeliveryFee = async () => {
    try {
      const response: any = await getDelverFee();

      setDeliveryFee(response.delivery_fee);
    } catch {}
  };

  const handleCardProducts = () => {
    const cart: any = storage.getCard();
    const mergedData = cart
      .map((cartItem: any) => {
        const product = singleProductData;
        if (product) {
          return { ...product, quantity: cartItem.quantity };
        }
        return null;
      })
      .filter(Boolean) as any;

    setCartProducts(mergedData);
  };

  useEffect(() => {
    fetchDeliveryFee();
  }, []);
  const handleGoToSignUp = () => {
    setDialogVisible(false);
    navigate("/register"); // Navigate to the sign-up page
  };
  const handleSingleProduct = async () => {
    try {
      const response = await getSingleProduct(productId);
      setSingleProductData(response.data);

      const transformedImages = response.data.images.map((image: Image) => ({
        original: image.image_path,
        thumbnail: image.image_path,
      }));

      setProductImages(transformedImages);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching product data:", error);
      setLoading(false);
    }
  };
  const handleDialogClose = () => {
    setDialogVisible(false);
  };

  useEffect(() => {
    handleSingleProduct();
  }, [productId]);
  const handleQuantityChange = () => {
    if (user) {
      handleCardProducts();
    } else {
      setDialogVisible(true);
    }
  };
  const handleIncrement = (e: any) => {
    if (user) {
      if (e) {
        e.stopPropagation();
      }
      setQuantity((prev) => {
        const newQuantity = prev + 1;
        storage.setCard(id, newQuantity);
        incrementOrderCount(true);
        return newQuantity;
      });
    }
  };
  const handleButtonClick = (e: any) => {
    e.stopPropagation();
    if (!user) {
      return;
    }

    if (buttonState === "add") {
      handleIncrement(null);
      setButtonState("added");
      setTimeout(() => setButtonState("remove"), 3000);
    } else if (buttonState === "remove") {
      handleDecrement(null);
      setButtonState("add");
    }
  };
  const handleDecrement = (e: any) => {
    if (user && quantity > 1) {
      e.stopPropagation();
      setQuantity((prev) => {
        const newQuantity = Math.max(0, prev - 1);
        storage.setCard(id, newQuantity);
        incrementOrderCount(false);
        return newQuantity;
      });
    }
  };
  const handleIncrementButton = (e: any) => {
    if (user) {
      e.stopPropagation();
      setQuantityButton((prev) => prev + 1);
    }
  };

  const handleDecrementButton = (e: any) => {
    if (user && quantityButton > 1) {
      e.stopPropagation();
      setQuantityButton((prev) => prev - 1);
    }
  };
  // Sync storage when quantity changes
  useEffect(() => {
    if (singleProductData) {
      storage.setCard(singleProductData.id, quantity);
    }
  }, [quantity]);

  const handleAddToCart = () => {
    if (user) {
      for (let i = 0; i < quantityButton; i++) {
        handleIncrement(null);
      }
    }
  };

  if (loading) {
    return <Loading />;
  }

  if (!singleProductData) {
    return <p className="text-center mt-4">لا يوجد منتج</p>;
  }

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center bg-no-repeat px-2 pt-16 pb-24"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundPosition: "center bottom 0rem",
      }}
    >
      `
      <div className="flex w-full flex-col lg:flex-row">
        <div className="md:w-1/2 w-full">
          <ReactImageGallery
            items={productImages}
            showPlayButton={false}
            showFullscreenButton={false}
            thumbnailPosition="bottom"
          />
        </div>

        <div className="md:w-1/2 w-full flex flex-col gap-4 p-6">
          <Card className="p-4 border">
            <CardContent>
              <h2 className="pb-4 text-2xl font-bold text-center">
                تفاصيل المنتج
              </h2>

              {/* Grid layout for details */}
              <div className="grid grid-cols-2 gap-4 text-gray-700">
                <div className="text-end">
                  {singleProductData.category.name_ar || "غير معروف"}
                </div>
                <div className="text-end font-semibold">فئة المنتج</div>

                <div className="text-end">
                  {singleProductData.name_ar || "غير معروف"}
                </div>
                <div className="text-end font-semibold">اسم المنتج</div>

                <div className="text-end">
                  {singleProductData.type_ar || "غير معروف"}
                </div>
                <div className="text-end font-semibold">نوع المنتج</div>

                <div className="text-end">
                  {singleProductData.origin_ar || "غير معروف"}
                </div>
                <div className="text-end font-semibold">الصناعة</div>

                <div className="text-end">
                  {singleProductData.volume || "غير معروف"}
                </div>
                <div className="text-end font-semibold">الحجم</div>

                <div className="text-end">
                  {`${singleProductData.price} ألف` || "غير معروف"}
                </div>
                <div className="text-end font-semibold">السعر</div>
              </div>

              {/* Full-width section for "تفاصيل أخرى" */}
              <div className="mt-4 w-full">
                <div className="text-end font-semibold">تفاصيل أخرى</div>
                <Textarea
                  className="text-end bg-gray-100 h-24 resize-none mt-1 w-full"
                  readOnly
                  value={
                    singleProductData.details_ar || "لا توجد تفاصيل إضافية."
                  }
                />
              </div>
            </CardContent>
          </Card>

          <div className="flex items-center justify-center gap-4 mt-4">
            {/* <button
              onClick={handleIncrement}
              className="bg-red-600 hover:bg-red-700 text-white py-2 px-6 rounded-lg font-semibold transition-colors text-sm"
            >
              إضافة إلى السلة
            </button> */}
            <button
              onClick={handleButtonClick}
              className="w-full py-2 px-4 rounded-lg font-semibold transition-colors text-white bg-red-600 hover:bg-red-700"
            >
              {buttonState === "add"
                ? "إضافة إلى السلة"
                : buttonState === "added"
                ? "تمت الإضافة"
                : "حذف من السلة"}
            </button>
            <Modal
              open={isDialogVisible}
              onCancel={handleDialogClose}
              footer={null}
              centered
            >
              <div className="bg-white p-6 rounded-lg w-full">
                <h3 className="text-xl mb-4 text-center">
                  يجب عليك إنشاء حساب أولاً
                </h3>
                <div className="flex justify-center gap-4">
                  <button
                    onClick={handleGoToSignUp}
                    className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded-md"
                  >
                    إنشاء حساب
                  </button>
                </div>
              </div>
            </Modal>
            {/* <button
              onClick={handleDecrementButton}
              className="text-red-600 w-10 h-10 rounded-lg flex items-center justify-center text-xl font-bold"
              disabled={quantityButton <= 1}
            >
              -
            </button>
            <span className="text-lg font-semibold w-8 text-center">
              {quantityButton}
            </span>
            <button
              onClick={handleIncrementButton}
              className="text-red-600 w-10 h-10 rounded-lg flex items-center justify-center text-xl font-bold"
            >
              +
            </button> */}
          </div>
        </div>
      </div>
    </div>
  );
};
